import { React } from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ScheduleVisit from "../../../dashboard/Buy-property/ScheduleVisit";
import { useTranslation } from "react-i18next";

const ScheduleVisitDialog = ({
  scheduleAppointment,
  setScheduleAppointment,
  id,
  getSinglePropertyList
}) => {
  const { t } = useTranslation();
  const dialogCloseHandler = () => {
    setScheduleAppointment(false);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={scheduleAppointment}
        onClose={dialogCloseHandler}
        aria-labelledby="schedule-visit-dialog"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #1A8CFF 0%, #0065CC 100%)",
              padding: "24px 28px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "18px",
                  lineHeight: 1.3,
                }}
              >
                {t("PostProperty.ScheduleForVisit")}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "12px",
                  mt: 0.5,
                }}
              >
                {t("PostProperty.ScheduleVisitSubtitle")}
              </Typography>
            </Box>
            <IconButton
              onClick={dialogCloseHandler}
              sx={{
                color: "#fff",
                backgroundColor: "rgba(255,255,255,0.15)",
                borderRadius: "10px",
                padding: "6px",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: "18px" }} />
            </IconButton>
          </Box>

          {/* Body */}
          <Box sx={{ padding: "28px" }}>
            <ScheduleVisit
              id={id}
              setScheduleAppointment={setScheduleAppointment}
              getPropertyDetails={getSinglePropertyList}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ScheduleVisitDialog;
